import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { HeroSection } from '~/ui-rocco/pages/home-page/sections/HeroSection';
import { IntroSection } from '~/ui-rocco/pages/home-page/sections/IntroSection';
import { FeatureStripSection } from '~/ui-rocco/pages/home-page/sections/FeatureStripSection';

/**
 * Editorial closing block for the revamped article page. Reuses the homepage
 * "About ArchiPro" blocks verbatim so the look and feel matches the rest of the
 * site, with the homepage spacing rhythm:
 *   - HeroSection  — "Where beautifully designed spaces begin" (desktop only;
 *     the mobile design opens straight on the intro).
 *   - IntroSection — "Creating a home is one of life's biggest investments…"
 *   - FeatureStripSection (content tiles only) — the four directory pillars,
 *     dropping the member-workspace tiles.
 *
 * The product, project and professional pages closed on this too until they
 * moved to the account band, which is why the block still reads as a shared
 * one — the article page is the only page left that ends this way.
 */
export const EditorialClosing = () => {
    return (
        <>
            <div className="max-md:hidden">
                <HeroSection variant="detail" />
                <SectionSpacer
                    height={197}
                    mobileHeight={59}
                    className="bg-white"
                    unit="rem"
                />
            </div>
            <IntroSection compactCta />
            <SectionSpacer
                height={168}
                mobileHeight={59}
                className="bg-white"
                unit="rem"
            />
            <FeatureStripSection contentOnly />
        </>
    );
};
